import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Button from '../button'
import styles from './password-reset-error.css'

/**
 * used by PasswordReset.
 * Informs the user that their reset link expired and guides them back to requesting another.
 */
export default function PasswordResetError({ passwordForgottenLocation }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Your previous attempt to reset your password has expired
        </h1>
      </div>

      <p className={styles.description}>
        Please submit another password reset email below.
      </p>

      <Link to={passwordForgottenLocation}>
        <Button className={styles.button} text="Reset Password" />
      </Link>
    </div>
  )
}

PasswordResetError.propTypes = {
  passwordForgottenLocation: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired
}
